// Copyright (C) 2020 TANNER AG

const LINK_OFFSET = 0;

/**
 * Hash link scroll functionality for React Router.
 * Note that this is for React Router v4/5.
 * Hook that scrolling to #hash-fragment after page is loading.
 * @see https://github.com/rafrex/react-router-hash-link/tree/06822346273c0548d79dacdf7d73ae48910c6b6f
 */

let hashFragment = "";
let observer = null;
let asyncTimerId = null;

const scrollFunction = (el) => {
    el.scrollIntoView(true);
    window.scrollBy(0, -LINK_OFFSET);
};

// Reset current observe - clear timeout
const reset = () => {
    hashFragment = "";

    if (observer) {
        observer.disconnect();
    }

    if (asyncTimerId !== null) {
        window.clearTimeout(asyncTimerId);
        asyncTimerId = null;
    }
};

// Return true if target element exists and scroll are executed - otherwise false
const getElAndScroll = () => {
    const element = document.getElementById(hashFragment);

    if (element) {
        scrollFunction(element);
        reset();
        return true;
    }

    return false;
};

const hashLinkScroll = () => {
    // Push onto callback queue so it runs after the DOM is updated
    window.setTimeout(() => {
        if (!getElAndScroll()) {
            if (!observer) {
                observer = new MutationObserver(getElAndScroll);
            }
            observer.observe(document, {
                attributes: true,
                childList: true,
                subtree: true,
            });
            // if the element doesn't show up in 10 seconds, stop checking
            asyncTimerId = window.setTimeout(() => {
                reset();
            }, 10000);
        }
    }, 0);
};

export const useHashLink = () => {
    return (hash) => {
        if (!hash) {
            return;
        }

        hashFragment = hash;
        hashLinkScroll();
    };
};



// WEBPACK FOOTER //
// ./src/emobility/usehashscroll.js